declare namespace $ {

	type $bog_smalljs_text_code__text_bog_smalljs_text_1 = $mol_type_enforce<
		ReturnType< $bog_smalljs_text['pre_text'] >
		,
		ReturnType< $bog_smalljs_text_code['text'] >
	>
	type $bog_smalljs_text_code__row_themes_bog_smalljs_text_2 = $mol_type_enforce<
		ReturnType< $bog_smalljs_text['pre_themes'] >
		,
		ReturnType< $bog_smalljs_text_code['row_themes'] >
	>
	type $bog_smalljs_text_code__highlight_bog_smalljs_text_3 = $mol_type_enforce<
		ReturnType< $bog_smalljs_text['highlight'] >
		,
		ReturnType< $bog_smalljs_text_code['highlight'] >
	>
	type $bog_smalljs_text_code__uri_resolve_bog_smalljs_text_4 = $mol_type_enforce<
		ReturnType< $bog_smalljs_text['uri_resolve'] >
		,
		ReturnType< $bog_smalljs_text_code['uri_resolve'] >
	>
	type $bog_smalljs_text_code__sidebar_showed_bog_smalljs_text_5 = $mol_type_enforce<
		ReturnType< $bog_smalljs_text['pre_sidebar_showed'] >
		,
		ReturnType< $bog_smalljs_text_code['sidebar_showed'] >
	>
	type $bog_smalljs_text_code__lang_bog_smalljs_text_6 = $mol_type_enforce<
		ReturnType< $bog_smalljs_text['pre_lang'] >
		,
		ReturnType< $bog_smalljs_text_code['lang'] >
	>
	type $bog_smalljs_text_code__run_enabled_bog_smalljs_text_7 = $mol_type_enforce<
		ReturnType< $bog_smalljs_text['pre_run_enabled'] >
		,
		ReturnType< $bog_smalljs_text_code['run_enabled'] >
	>
	type $bog_smalljs_text_code__playground_arg_bog_smalljs_text_8 = $mol_type_enforce<
		ReturnType< $bog_smalljs_text['pre_playground_arg'] >
		,
		ReturnType< $bog_smalljs_text_code['playground_arg'] >
	>
	type $bog_smalljs_text_code__playground_showed_bog_smalljs_text_9 = $mol_type_enforce<
		ReturnType< $bog_smalljs_text['pre_playground_showed'] >
		,
		ReturnType< $bog_smalljs_text_code['playground_showed'] >
	>
	type $bog_smalljs_structure__tree_bog_smalljs_text_10 = $mol_type_enforce<
		ReturnType< $bog_smalljs_text['pre_text'] >
		,
		ReturnType< $bog_smalljs_structure['tree'] >
	>
	export class $bog_smalljs_text extends $mol_text {
		pre_text( id: any): string
		pre_themes( id: any): readonly(string)[]
		highlight( ): string
		uri_resolve( id: any): string
		code_sidebar_showed( ): boolean
		pre_sidebar_showed( ): ReturnType< $bog_smalljs_text['code_sidebar_showed'] >
		pre_lang( id: any): string
		pre_run_enabled( id: any): boolean
		pre_playground_arg( id: any): Record<string, any>
		pre_playground_showed( id: any): boolean
		Pre( id: any): $bog_smalljs_text_code
		Structure( id: any): $bog_smalljs_structure
	}
	
	type $mol_button_minor__click_bog_smalljs_text_code_1 = $mol_type_enforce<
		ReturnType< $bog_smalljs_text_code['run_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__hint_bog_smalljs_text_code_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_bog_smalljs_text_code_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $bog_smalljs_text_live__tree_bog_smalljs_text_code_4 = $mol_type_enforce<
		ReturnType< $bog_smalljs_text_code['text'] >
		,
		ReturnType< $bog_smalljs_text_live['tree'] >
	>
	type $mol_link__arg_bog_smalljs_text_code_5 = $mol_type_enforce<
		ReturnType< $bog_smalljs_text_code['playground_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__hint_bog_smalljs_text_code_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['hint'] >
	>
	type $mol_link__sub_bog_smalljs_text_code_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	export class $bog_smalljs_text_code extends $mol_text_code {
		run_click( next?: any ): any
		Run_icon( ): $mol_icon_play
		Playground_icon( ): $mol_icon_launch
		lang( ): string
		playground_arg( ): Record<string, any>
		playground_showed( ): boolean
		run_enabled( ): boolean
		run( next?: boolean ): boolean
		attr( ): ({ 
			'bog_smalljs_run_active': ReturnType< $bog_smalljs_text_code['run'] >,
		})  & ReturnType< $mol_text_code['attr'] >
		Run( ): $mol_button_minor
		Live( ): $bog_smalljs_text_live
		Playground( ): $mol_link
	}
	
	type $mol_view__sub_bog_smalljs_text_live_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_text_live_2 = $mol_type_enforce<
		ReturnType< $bog_smalljs_text_live['live_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_smalljs_text_live extends $mol_view {
		label_text( ): string
		Label( ): $mol_view
		live_content( ): readonly(any)[]
		Output( ): $mol_view
		tree( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=text.view.tree.d.ts.map